import { ReceiptLineSalesComponent } from './receipt-line-sales.component';

export default angular
  .module('sfMobile.components.receipt-line-sales', [
    'sfMobile.constants.currencies',
    'sfMobile.components.receipt-line-product',
  ])
  .component('sfReceiptLineSales', ReceiptLineSalesComponent).name;
